import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {alpha, useTheme} from '@mui/material/styles';
import {ActionFooter} from 'wobi-web-common/dist/v2/index.js';
import {TEST_IDS} from '../config/testIds';

const ArrowIcon = () => (
  <svg width={18} height={18} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round'>
    <path d='M5 12h14' />
    <path d='M12 5l7 7-7 7' />
  </svg>
);

const ArrowLIcon = () => (
  <svg width={20} height={20} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round'>
    <path d='M19 12H5' />
    <path d='M12 19l-7-7 7-7' />
  </svg>
);

const FlowFooter = ({
  onBack,
  onNext,
  nextLabel,
  nextDisabled = false,
  nextLoading = false,
  backLabel,
  primaryButtonProps,
  showBackButton = true,
}) => {
  const intl = useIntl();
  const theme = useTheme();
  return <ActionFooter
    className='flow-footer'
    style={{
      '--travel-footer-background': theme.palette.background.paper,
      '--travel-footer-shadow': `0 -6px 20px ${alpha(theme.palette.secondary.dark, 0.1)}`,
    }}
    ariaLabel={intl.formatMessage({id: 'flowFooter.ariaLabel'})}
    secondaryLabel={showBackButton ? backLabel || intl.formatMessage({id: 'back'}) : undefined}
    onSecondary={onBack}
    secondaryButtonProps={{'data-testid': TEST_IDS.flow.back}}
    secondaryIconStart={<ArrowIcon />}
    primaryLabel={nextLabel || intl.formatMessage({id: 'continue'})}
    onPrimary={onNext}
    primaryDisabled={nextDisabled}
    primaryLoading={nextLoading}
    primaryIconEnd={<ArrowLIcon />}
    primaryButtonProps={primaryButtonProps}
    mobileSticky
  />;
};

FlowFooter.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func.isRequired,
  nextLabel: PropTypes.node,
  nextDisabled: PropTypes.bool,
  nextLoading: PropTypes.bool,
  backLabel: PropTypes.node,
  primaryButtonProps: PropTypes.object,
  showBackButton: PropTypes.bool,
};

export default FlowFooter;
